/**
 * User Tasks API — List a user's open action items.
 *
 * GET /v1/user-tasks
 *
 * Read-time aggregation across registered resolvers, scoped to the subject
 * user's own obligations + delegated subjects + audience, minus the subject's
 * dismissed/completed items, ranked by due date then urgency. Ships dark:
 * returns `{ tasks: [], count: 0 }` in production until a real resolver registers.
 *
 * `userId` (optional) is the subject user whose tasks are listed. Omitted → the
 * authenticated user (self). Supplied & ≠ self → requires school-admin /
 * super-admin (view-as); a member may only list their own tasks.
 */

import { z } from 'zod'

import { UserTaskSchema } from '../../schemas/entities/user-task'

export const ListUserTasksQuerySchema = z.object({
  /** Subject user (UsersOnSchools.publicId) to view; omit for self. */
  userId: z.string().min(1).optional()
})
export type ListUserTasksQuery = z.infer<typeof ListUserTasksQuerySchema>

export const ListUserTasksResponseSchema = z.object({
  tasks: z.array(UserTaskSchema),
  /** Count of returned (non-dismissed, non-completed) tasks. */
  count: z.number().int().nonnegative()
})

export type ListUserTasksResponse = z.infer<typeof ListUserTasksResponseSchema>
